import axios from 'axios';
import moment from 'moment';
import React, { useEffect } from 'react';
import { alertRef } from '../../../App';
import { Button, Textarea } from '../../../Components/StyledComponents';
import { convertCost } from '../../../Utils/functions';
import './Point.scss';

const Point = ({info,getInfo}) => {
    const [ list, setList ] = React.useState([])//포인트 내역
    const [ memo, setMemo ] = React.useState('')//고객 메모
    const [ isModify, setIsModify ] = React.useState(false)//메모 수정 여부

    //고객 정보 Get info prop 바뀔때마다 호출
    useEffect(() => {
        if(typeof info.UserInfo !== 'undefined'){
            setMemo(info.Memo)
            axios.get('/api/customer/info/point/' + info.UserInfo._id.$oid)
            .then((data) => {
                if(Object.keys(data.data).length > 0) setList(data.data.History)
            })
        }
    },[info])

    //고객 메모 handler
    const handleSaveBtn = () => {
        if(!isModify){
            setIsModify(true)
            setTimeout(() => {
                document.getElementById('input-memo').focus()
            }, 10);
        }else {
            saveMemo()
        }
    }

    //고객 메모 저장
    const saveMemo = () => {
        axios.post('/api/customer/info/memo/' + info.UserInfo._id.$oid,{ Memo : memo })
        .then((data) => {
            if(data.status === 204){
                alertRef.current.showAlert({ title : `메모가 수정되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();setIsModify(false);getInfo()} })
            }
        })
    }

    return (
        <div className='user-point'>
            {
                (Object.keys(info).length > 0 && typeof info.UserInfo !== 'undefined') && 
                <>
                    <div className='edit-btn-row'>
                        <Button variant={ isModify ? 'main' : 'sub'} small style={{ width : 88, alignSelf : 'flex-end', marginBottom : 16 }} onClick={() => handleSaveBtn()}>
                            { isModify ? '저장하기' : '수정하기'}
                        </Button>
                    </div>
                    <div className='row between'>
                        <div className='row'>
                            <div className='user-icon-box'>
                                <img src={require('../../../aseets/icons/user.svg').default} style={{ width : 56, height : 56 }} />
                            </div>
                            <div>
                                <p className='user-tel'>{info.UserInfo.Tel} 님</p>
                                <p className='user-date'>{moment(info.RegDate.$date).utc().format('YYYY.MM.DD')} 가입</p>
                            </div>
                        </div>

                        <div className='row between' style={{ alignItems : 'flex-start'}}>
                            <Textarea
                                id="input-memo"
                                value={memo}
                                onChange={(e) => setMemo(e.target.value)}
                                placeholder='고객에 대해 간단하게 메모 해주세요.'
                                style={{ width : 540, height : 80, paddingTop : 8 }}
                                disabled={!isModify}
                            />
                        </div>
                    </div>

                    <div className='user-info-box'>
                        <div className='info'>
                            <p className='info-title'>적립 횟수</p>
                            <p className='info-text'>{convertCost(info.PointCount)}회</p>
                        </div>
                        <div className='info'>
                            <p className='info-title'>보유 포인트</p>
                            <p className='info-text' style={{ color : '#f95f53', textDecorationLine : 'underline'}}>{convertCost(info.Point)}P</p>
                        </div>
                        <div className='info'>
                            <p className='info-title'>적립 포인트</p>
                            <p className='info-text'>{convertCost(info.AddPointCount)}P</p>
                        </div>
                        <div className='info' style={{ borderRightWidth : 0}}>
                            <p className='info-title'>사용 포인트</p>
                            <p className='info-text'>{convertCost(info.UsePointCount)}P</p>
                        </div>
                    </div>
                </>
            }
            

            <div className='row between'>
                <p className="sub-title">최근 포인트 내역</p>
                <Button disabled variant='sub' style={{ paddingLeft : 16, paddingRight : 16, paddingTop : 8, paddingBottom : 8 }}>
                    총 {convertCost(list.length)}건
                </Button>
            </div>

            <table>
                <tbody>
                    <tr>
                        <th>사용일시</th>
                        <th>결제금액</th>
                        <th>구분</th>
                        <th>적립/사용</th>
                        <th>잔여포인트</th>
                    </tr>
                    {
                        list.map((data,i) => {
                            return(
                                <tr key={i}>
                                    <td>{moment(data.Date.$date).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</td>
                                    <td>{convertCost(data.Price)}원</td>
                                    <td>{data.Type === 'Delivery' ? '배달/포장' : data.Type === 'Commerce' ? '커머스 쿠폰' : '매장'}</td>
                                    <td style={{ color : '#3f3f3f'}}>{convertCost(data.Point)} P</td>
                                    <td style={{ color : '#3f3f3f'}}>{convertCost(data.RemainPoint)} P</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Point;